import { Calendar } from "./Calendar";
import { TermCalendar } from "./TermCalendar";
export class TermCalendars {
    _calendars = [];
    _primary;
    constructor(params) {
        if (params.calendars) {
            this.calendars = params.calendars;
        }
        this.primary = params.primary;
        this.updateJsValues();
    }
    set primary(value) {
        if (value instanceof Calendar) {
            this._primary = value;
            return;
        }
        this._primary = new Calendar(value);
    }
    get primary() {
        return this._primary;
    }
    updateModelValues() {
        this._calendars.forEach((bm) => bm.updateModelValues());
    }
    updateJsValues() {
        this._calendars.forEach((bm) => bm.updateJsValues());
    }
    get calendars() {
        return this._calendars;
    }
    get hasCustomCalendars() {
        return this._calendars.length > 0;
    }
    getCalendarForTerm(term, includeInactive = false) {
        const calendar = this._calendars.find((c) => c.termNumber === term && (c.active === true || includeInactive));
        if (calendar) {
            return calendar.calendar;
        }
        return this.primary;
    }
    hasCalendarForTerm(term) {
        return this._calendars.some((c) => c.termNumber === term);
    }
    isDuplicateTermNumber(termNumber) {
        return this._calendars.filter((val) => val.termNumber === termNumber).length > 1;
    }
    deactivateAll() {
        this._calendars.forEach((bm) => (bm.active = false));
    }
    activateAll() {
        this._calendars.forEach((bm) => (bm.active = true));
    }
    set calendars(value) {
        this._calendars = value.map((c) => {
            if (c instanceof TermCalendar) {
                return c;
            }
            return new TermCalendar(c);
        });
    }
    get all() {
        return this._calendars;
    }
    get active() {
        return this._calendars.filter((bm) => bm.active === true);
    }
    reSort() {
        this.updateModelValues();
        this._calendars = this._calendars.sort((a, b) => {
            return a.termNumber - b.termNumber;
        });
        this.updateJsValues();
    }
    addCalendar(schedule) {
        this._calendars.push(schedule);
    }
    removeCalendarAtIndex(index) {
        this._calendars.splice(index, 1);
    }
    removeAllCalendars() {
        this._calendars = [];
    }
    get length() {
        return this._calendars.length;
    }
    atIndex(index) {
        return this._calendars[index];
    }
    get first() {
        return this._calendars[0];
    }
    get last() {
        return this._calendars[this._calendars.length - 1];
    }
    get json() {
        const json = this._calendars.map((s) => s.json);
        const valueToReturn = {
            calendars: json,
            primary: this.primary.calendarType,
        };
        return valueToReturn;
    }
}
